import { FC, ReactElement, useMemo } from 'react'
import classNames from 'classnames'
import { isArray } from 'lodash'


export type Size = {
    width: number | string,
    height: number | string
}

export type LogoIconProps = {
    // Size of icon, Default 50
    size?: number | string | Size;
    // Color of logo, Default black
    color?: string;
    className?: classNames.Argument | classNames.Argument[];
}

export const LogoIcon: FC<LogoIconProps> = (props: LogoIconProps): ReactElement => {
    const { size = 50, color = 'black', className = [] } = props
    
    const logoSizes: Size = useMemo(() => {
        if (typeof size !== 'object')
            return { width: size, height: size }
        
        return size
    }, [size])
    
    const logoClassName: classNames.ArgumentArray = useMemo(() => {
        if (isArray(className)) return className
        return [className]
    }, [className])
    
    return (<svg
        className={classNames(...logoClassName)}
        width={logoSizes.width}
        height={logoSizes.height}
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M44.7202 2H31.8843C31.634 2 31.431 2.20138 31.431 2.44979V31.8274C31.431 32.0758 31.634 32.2772 31.8843 32.2772H44.7202C44.9705 32.2772 45.1734 32.0758 45.1734 31.8274V2.44979C45.1734 2.20138 44.9705 2 44.7202 2Z"
            fill={color}
        />
        
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8438 25.8243C13.4514 15.2396 14.8943 2.44979 14.8943 2.44979C14.8943 2.20138 14.6914 2 14.4411 2H2.28911C2.03879 2 1.83587 2.20138 1.83587 2.44979C1.83587 2.44979 -0.479153 14.6053 0.0900665 28.0942C0.581374 39.7369 9.60917 48.6667 21.3516 48.6667H49.5468C49.7971 48.6667 50 48.4653 50 48.2169V36.0058C50 35.7574 49.7971 35.556 49.5468 35.556L23.5583 35.556C18.1515 35.556 14.0426 31.1863 13.8438 25.8243Z"
            fill={color}
        />
    </svg>)
}